<template>
    <AppParallaxeTitle v-if="!isMobile">
        <h1 class="title" :class="classList" > 
            <span class="title__text is-clickable" v-if="clickTitle" @click="onClickTitle"> {{ title }} </span>
            <span class="title__text" v-else> {{ title }} </span>
        </h1>
    </AppParallaxeTitle>
    <h1 v-else class="title" :class="classList"> {{ title }} </h1>
</template>

<script>
import EventHub from '@/utils/EventHub'

import AppParallaxeTitle from '@/components/AppParallaxeTitle'

export default {
  name: 'app-title',

  components: {
      AppParallaxeTitle
  },

  props: {
      title: {
          type: String,
          default: 'labor of fashion'
      },
      size: {
          type: String,
          default: 'little'
      },
      translated: {
          type: Boolean,
          default: false
      },
      clickTitle: {
          type: Boolean,
          default: false
      } 
  },

  computed: {
      classList: function() {
          return { 
              'title--little': this.size === 'little',
              'title--medium': this.size === 'medium',
              'title--big': this.size === 'big',
              'is-translated': this.translated
          }
      }
  },
  data() {
    return {
        isMobile: false
    }
  },

  created()
  {
      this.addEventListeners()
  },

  mounted()
  {
      this.onResize({width: window.innerWidth, height: window.innerHeight})
  },

  destroyed()
  {
      this.removeEventListeners()
  },

  methods: {
      addEventListeners()
      {
          EventHub.$on('window:resize', this.onResize)
      },

      removeEventListeners()
      {
          EventHub.$off('window:resize', this.onResize)
      },

      onClickTitle()
      {
          this.$parent.onClickHomeTitle()
      },

      onResize(windowObj)
      {
          if(windowObj.width <= 768)
          {
              this.isMobile = true
          }
          else
          {
              this.isMobile = false
          }
      }
  }
}
</script>

<style lang="stylus"> 
    .title
        width 100%
        font-family 'Sabon'
        text-transform uppercase
        text-align center
        line-height 1

        &.is-translated

            .title__text
                transform translateY(53%)
                display block
                position relative

        &--little
            letter-spacing 0.2em
            interpolate('padding-top', 1600px, 2560px, 300px, 460px);
            interpolate('font-size', 1600px, 2560px, 120px, 172px);

            @media(max-width 1600px)
                interpolate('padding-top', 768px, 1600px, 180px, 300px);
                interpolate('font-size', 768px, 1600px, 58px, 120px);

            @media(max-width: 768px)
                padding-top $space-y-mobile
                font-size 20px

        &--medium
            letter-spacing 0.05em
            interpolate('padding-top', 1600px, 2560px, 175px, 250px);
            interpolate('font-size', 1600px, 2560px, 198px, 284px);

            @media(max-width 1600px)
                interpolate('padding-top', 768px, 1600px, 122px, 175px);
                interpolate('font-size', 768px, 1600px, 99px, 198px);

            @media(max-width: 768px)
                padding-top $space-y-mobile
                font-size 45px

        &--big
            letter-spacing 0.05em
            interpolate('padding-top', 768px, 2560px, 120px, 380px);
            interpolate('font-size', 768px, 2560px, 246px, 820px);

            @media(max-width: 768px)
                padding-top $space-y-mobile
                font-size 45px

        @media(max-width 768px)
            text-align left

    .title__text

        &.is-clickable
            cursor pointer
</style>